export default "__VITE_ASSET__D3K6joN1__"